export default[
	{
		path: '/merchantdetail',
		name: 'merchantDetail',
    meta:{
      title:'厂商详情'
    },
		component: () => import('@/views/merchant/MerchantDetail.vue')
	},
	{
		path: '/merchantlist',
		name: 'merchantList',
    meta:{
      title:'厂商列表'
    },
		component: () => import('@/views/merchant/MerchantList.vue')
	},
]



// WEBPACK FOOTER //
// ./src/router/merchant.js